import { Component, input } from '@angular/core';

@Component({
  selector: 'td-wb-lti-step',
  templateUrl: './lti-step.component.html',
  styleUrls: ['./lti-step.component.scss']
})
export class LtiStepComponent {
  readonly step = input<number>(undefined);
}
